module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_07@2x-1ba504db6ccebcdc3fe39d2f03b0c77d.jpg";